import styled, { css } from 'styled-components';
import { Theme } from '@routific/hive';

export enum DropzonePosition {
  TOP = 'top',
  BOTTOM = 'bottom',
}

const TimelineCardDropZone = styled.div<{ type: DropzonePosition, index: number }>`
  position: absolute;
  ${(props) => props.type}: 0;
  left: 0;
  right: 0;
  height: 2px;
  background-color: ${Theme.Colors.primary6};
  width: 100%;
  z-index: 9999;
  ${({ index, type }) => index !== 0 && css`
    transform: ${type === 'bottom' ? 'translateY(1px)' : 'translateY(-1px)'};
  `}
  pointer-events: none;
`;

export default TimelineCardDropZone;
